const typography = {
  headerStep: {
    fontFamily: "'Noto Sans JP', sans-serif",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "32px",
    color: "#222222",
  },
  sectionLabel: {
    fontFamily: "'Noto Sans JP', sans-serif",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "neutral.textPrimary",
  },
  formLabel: {
    fontFamily: "'Noto Sans JP', sans-serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "neutral.textSecondary",
  },
  inputBody: {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "neutral.textPrimary",
  },
  helperText: {
    fontFamily: "'Noto Sans JP', sans-serif",
    fontWeight: 400,
    fontSize: "11px",
    lineHeight: "16px",
    color: "#999999",
  },
  ctaButton: {
    fontFamily: "'Noto Sans JP', sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFFFFF",
  },
};
export default typography;
